import(/* webpackMode: "eager" */ "/vercel/path0/web/app/global-error.tsx");
